var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 142.5,
    height: 145.231,
    viewBox: "0 0 142.5 145.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#efab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#e1d159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4694ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#576298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76578f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_24",
    "data-name": "Intersection 24",
    d: "M67.845,145.231v-39.92H49.458l-19.28,38.777-3.124-1.553L60.386,75.5a12.537,12.537,0,0,1-3.314-6.341l-7.306,1.7L46.91,60.928l-25.8,6.4,1.066,3.752L6.408,76.236,0,53.66l15.765-5.149.94,3.308,25.67-6.641-2.446-8.5L91.413,20.373l-2.138-7.691L126.59,0,142.5,57.693V57.7l-38.539,7.8-1.892-6.8L81.5,63.476a12.426,12.426,0,0,1-3.873,12.751l32.969,66.309-3.124,1.553-19.28-38.777H71.333v39.92Zm3.488-66.072v22.664H86.455L74.682,78.14A12.521,12.521,0,0,1,71.333,79.159ZM51.194,101.823H67.845v-22.6A12.449,12.449,0,0,1,63.2,77.676ZM60.1,66.768a9.293,9.293,0,1,0,9.292-9.291A9.3,9.3,0,0,0,60.1,66.768ZM4,55.786,8.62,72.079l9.559-3.123L13.555,52.665ZM43.944,38.831l8.1,28.141,4.842-1.126a12.536,12.536,0,0,1,23.328-5.421L101.2,55.557,92.287,23.518ZM17.6,54.959l2.622,9.233,25.786-6.4-2.728-9.478ZM93.243,14.776,106.291,61.7l32.135-6.509L124.364,4.2Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluate);
export default __webpack_public_path__ + "static/media/evaluate.92fcae8dc4c520db4ff6ddd4c7216f31.svg";
export { ForwardRef as ReactComponent };